import { Component, Input } from '@angular/core';
import { Bill } from '../types/types';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'ucx-js-card',
  templateUrl: './billing-card.component.html',
  styleUrls: ['./billing-card.component.scss'],
})
export class BillingCardComponent {
  @Input() bill: Bill = new Bill();
  currentDate = new Date();
}
